import { useCallback } from 'react'
import { useClientDashboardLogin } from './ClientDashboardLoginContext'

export const useClientDashboardLoginOverlayTrigger = () => {
  const { openLoginOverlay } = useClientDashboardLogin()

  const openOverlayInsteadOfNavigating = useCallback(
    (e) => {
      e.preventDefault()
      openLoginOverlay()

      return true
    },
    [openLoginOverlay]
  )

  return { overlayEnabled: true, openOverlayInsteadOfNavigating }
}
